'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { useIsLoggedIn } from '@air/utils-auth';

import { ROUTES } from '~/constants/routes';

export const useUnauthenticatedRedirect = () => {
  const { isLoggedIn, isLoggedInFetched } = useIsLoggedIn();
  const router = useRouter();

  useEffect(() => {
    if (isLoggedInFetched && !isLoggedIn) {
      router.push(ROUTES.LOGIN);
    }
  }, [isLoggedIn, isLoggedInFetched, router]);
};
